import { TherapistTherapiesInfoRequestDtoSpecialisationEnum } from '@app/api';

export const getSpecializations = (
  specialization: TherapistTherapiesInfoRequestDtoSpecialisationEnum,
) => {
  switch (specialization) {
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Coach:
      return 'Коуч';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Psychologist:
      return 'Психолог';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Psychoanalyst:
      return 'Психиатр';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Supervisor:
      return 'Супервизор';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.ClinicalPsychologist:
      return 'Клинический психолог';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Sexologist:
      return 'Сексолог';
    default:
      break;
  }
};
export const getSpecializationTips = (
  specialization: TherapistTherapiesInfoRequestDtoSpecialisationEnum,
) => {
  switch (specialization) {
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Coach:
      return 'Коуч — наставник, который помогает человеку достигать личных или профессиональных целей, развивая навыки, раскрывая потенциал и поддерживая мотивацию. Коуч не работает с психологическими проблемами и не ставит диагнозов.';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Psychologist:
      return 'Психолог — специалист, который помогает людям лучше понять свои эмоции, поведение и внутренние конфликты. Он работает с психологическим благополучием, используя научные методы и консультации, но не занимается лечением медицинских диагнозов.';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Psychoanalyst:
      return 'Психиатр';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Supervisor:
      return 'Супервизор — опытный профессионал, который помогает психологам и психотерапевтам совершенствовать их работу, анализируя сложные случаи, предоставляя поддержку и обеспечивая соблюдение этических стандартов в их практике.';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.ClinicalPsychologist:
      return 'Клинический психолог — специалист, который занимается диагностикой и коррекцией психологических состояний, связанных с психическими расстройствами. Он часто работает в медицинских учреждениях и обладает знаниями в области психиатрии, но не назначает лекарства.';
    case TherapistTherapiesInfoRequestDtoSpecialisationEnum.Sexologist:
      return 'Сексолог - специалист с профильной подготовкой, консультирующий по вопросам сексуального здоровья, психосексуального развития и интимных отношений.';
    default:
      break;
  }
};
